module.exports = __webpack_public_path__ + "assets/images/vcr_restaurant-01.584ed2a135bca35b5698622bf0edfce2.svg";